module.exports = __webpack_public_path__ + "static/media/hollow-fork.070a367f.svg";